module.exports = __webpack_public_path__ + "img/cszq_banner_2_mobile.b95f05d2.png";